import styled from "styled-components";

const Section = styled.section`
  color: white;
  margin-bottom: 100px;
  
`;
export default Section;
